import React, { useCallback, useEffect } from 'react';
import { Typography } from '@worthy-npm/worthy-common-ui-components';
import { debounce } from 'lodash';

import { Step, StepContainer, StepGridContainer } from '../../../styles/common';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectCondition, updateCondition } from '../../../slices/submitSlice';
import { StepProps } from '../common';
import StepTitle from '../../stepTitle';
import { DEBOUNCE_DELAY, DEBOUNCE_OPTIONS } from '../../../data/constants';
import { parametrize } from '../../../lib/commonUtils';
import GA from '../../../data/GA';
import { WatchConditions } from '../../../data/ItemDetails';
import { StyledButton, StyledList } from '../../common/ButtonsList';

function StepCondition({
  next,
  active,
  idx,
  stepName,
  prev,
  title,
  stepCaption,
  props,
}: StepProps) {
  const dispatch = useAppDispatch();
  const condition = useAppSelector(selectCondition);

  const debouncedClickHandler = useCallback(
    debounce((e: React.MouseEvent<HTMLElement>, itemCode: string) => {
      GA.select({ step: stepName, value: itemCode });
      dispatch(updateCondition(itemCode));
      next(e);
    }, DEBOUNCE_DELAY, DEBOUNCE_OPTIONS) as (e: React.MouseEvent<HTMLElement>, itemCode: string) => void,
    [next, stepName, dispatch],
  );

  useEffect(() => {
    if (!active) return;
    GA.stepView(stepName);
  }, [active]);

  return (
    <StepContainer data-automation="condition-step">
      <Step>
        <StepTitle
          stepCaption={stepCaption}
          prev={prev}
          stepTitle={title || 'What condition is your watch in?'}
          stepNotice="Select an option below"
          optionalProps={props || {}}
        />

        <StepGridContainer>
          <StyledList>
            {WatchConditions.map((item) => (
              <StyledButton
                data-automation={`condition-step-item-${parametrize(item.code)}`}
                key={item.code}
                onClick={(e) => {
                  debouncedClickHandler(e, item.code);
                }}
                // selected={item.code === condition}
              >
                <Typography variant="body1">{item.text}</Typography>
              </StyledButton>
            ))}
          </StyledList>
        </StepGridContainer>
      </Step>
    </StepContainer>
  );
}

export default StepCondition;
